import React from 'react'
import {
	Column, TreeColumn, WidgetCell, TyanLineProcessing
} from '@sencha/ext-modern'

import { getFileIcon } from '../..'
import { reconfigButton, nullDate, TDate, getListFromValues } from 'tyan/public/utility'
import { getColumnFilterTool } from './filter'
import { getDownloadUrl } from '../Form/Block/renderFiles/fileServeDispatch'

import {
	renderText, renderRichText,
	renderInt, renderNumber, renderFloat,
	renderDate,
	renderDateTime,
	renderButton,
	renderButtons,
	renderMenuButtons,
	renderMinibuttons,
	renderFlow,
	renderColumns,
	renderLineProcessing2,
} from './renderers'

import { truePromise, getBindedProps } from './renderers/utilities'

import FilesEditor from './FilesEditor'
import BatchEditor from './BatchEditor'

import { genFileText } from '../Form/Block/renderFiles'
import { showContextMenu } from './contextmenu'

const disableSelectionCls = 't_unselectable'
export const selectionCheckboxClsField = '_selectionCls'

const columnSwitch = {
	_: { render: () => null },
	_columns: { render: renderColumns },
	_text: { render: renderText },
	_richtext: { render: renderRichText },
	_int: { render: renderInt },
	_number: { render: renderNumber },
	_float: { render: renderFloat },
	_date: { render: renderDate },
	_datetime: { render: renderDateTime },
	_tree: {
		render: ({ _tree: text, dataIndex, ...rest }) => {
			return <TreeColumn dataIndex='_treeData' text={text} {...rest} />
		}
	},
	_tools: {
		textField: 'title',
		render: ({ _tools, title, ...rest }) => {
			return <Column text={title} {...rest} menuDisabled />
		}
	},
	_button: { textField: 'title', render: renderButton },
	_buttons: { textField: 'title', render: renderButtons },
	_minibuttons: { render: renderMinibuttons },
	_menubuttons: { textField: 'title', render: renderMenuButtons },
	_flow: { textField: 'title', render: renderFlow },
	_lineProcessing: {
		render: ({ _lineProcessing: text, ...props }) => {
			return (<Column text={text} {...props} /* sortable={false}  */ groupable={false} menuDisabled>
				<WidgetCell height='40px'>
					<TyanLineProcessing userCls='t-grid-lineprocessing' />
				</WidgetCell>
			</Column>)
		}
	},
	_lineProcessing2: {
		render: renderLineProcessing2
	},
	_files: {
		render: ({ _files: text, ...props }) => {
			return <Column text={text} {...props} groupable={false} menuDisabled />
		}
	}
}

const fieldTypes = Object.keys(columnSwitch)
// 数据字段类型
export const dataFieldTypes = [
	'_text', '_richtext', '_int', '_number', '_float', '_date', '_datetime', '_tree',
	'_lineProcessing', '_lineProcessing2', '_files', '_'
]
// 可自由配置的列项类型
const configableTypes = dataFieldTypes.slice(0, dataFieldTypes.length - 1)
// 可导出的列项类型
const exportableTypes = configableTypes

for (const f of fieldTypes) columnSwitch[f].textField = columnSwitch[f].textField || f

/**
 * 读取列项类型
 * @param {*} columnPar 
 * @returns 
 */
export const getColumnType = columnPar => {
	const type = fieldTypes.find(o => columnPar[o] !== undefined)
	!type && console.error('column is not defined :', columnPar)
	return type
}

/**
 * 读取列项的名称
 * @param {*} column 
 */
export const getColumnName = column => {
	const type = getColumnType(column)
	return column.name || column.field || column[type]
}

const syncfusionEditTypes = ['_date', '_datetime']

// 列项定义中的操作属性
const operatorProps = ['tools']

// 列项定义中导出不需要的属性
const notExportProps = ['filter', 'search', 'edit']

/**
 * 取可配置列，不改变列项内配置内容
 * @param {*} columns 
 * @returns 
 */
export const getConfigableColumns = columns => columns.filter(col => configableTypes.includes(getColumnType(col)))

/**
 * 取不可配置列，不改变列项内配置内容
 * @param {*} columns 
 * @returns 
 */
export const getUnconfigableColumns = columns => columns.filter(col => !configableTypes.includes(getColumnType(col)))

/**
 * 过滤掉columns中的操作按钮，需要保留原配置信息
 * @param {*} columns 
 * @returns 
 */
export const filterOperator = columns => getConfigableColumns(columns)
	.map(col => {
		const ret = { ...col }
		operatorProps.forEach(op => delete ret[op])
		return ret
	})

/**
 * 过滤掉 导出 不需要的列项及配置项, 需要保留原配置信息
 * @param {*} columns 
 * @returns 
 */
export const filterForExport = columns => columns
	.filter(col => exportableTypes.includes(getColumnType(col)))
	.map(col => {
		const ret = { ...col }
		operatorProps.concat(notExportProps).forEach(op => delete ret[op])
		return ret
	})

export const renderColumn = (columnPar, key, that, forViewModel = false, checkGridData = truePromise, columnConfigPsn = {}) => {
	const type = getColumnType(columnPar)
	if (!type) {
		return null
	}
	const { ...column } = reconfigColumn(type, columnPar, that, key, forViewModel, checkGridData)

	const psnConfig = columnConfigPsn[column.dataIndex] || {}
	psnConfig.width && delete column.flex	// 前台个性化配置中有宽度设置时，删除flex属性

	return columnSwitch[type].render({
		key,
		...(column[columnSwitch[type].textField] && {} || { locked: 'right', [columnSwitch[type].textField]: '&nbsp' }),
		...(key && {} || { locked: 'left' }),
		...column, ...psnConfig
	}, that, forViewModel, checkGridData)
}

const reconfigColumn = (colType, columnPar, that, key, forViewModel, checkGridData = truePromise) => {
	const reconfigEdit = edit => {
		const ret = { bind: {} }
		const { bind } = ret

		Object.entries(edit).forEach(([k, v]) => {
			typeof v === 'function'
				? bind[k] = `{${forViewModel ? '' : 'record.'}edit_${k}${key}}`
				: ret[k] = v
		})
		// console.log('ret:', ret)
		return ret
	}

	let {
		search, filter, sortable, field, local, filterProp, filterChoices, onFilterChange,
		prompt,
		tools: toolsPar, _tools, ui, style, tooltip,
		columnTools, 	// 列图标按钮定义
		handleEdit, edit, handleBatchEdit, batchEdit,
		...column
	} = columnPar

	column.dataIndex = column.name || column[colType]
	columnTools = [].concat(columnTools ?? [])

	filterProp && (column.sorter = { ...(column.dataIndex ? { id: column.dataIndex } : {}), sorterFn: Ext.emptyFn })

	// 应汪总要求，不要加图标，直接在列头上使用tooltip
	// // 添加 prompt 图标
	// columnTools = columnTools.concat(prompt ? {
	// 	iconCls: 'x-fa fa-question-circle', zone: 'head',
	// 	// style: { padding: '1px 2px 1px 1px', color: '#ff8c00' },
	// 	ui: 'yellow',
	// 	tooltip: [].concat(prompt).join('<br>'),
	// 	// margin: '0 20 0 0'
	// } : [])
	const title = column.title || column[colType]
	prompt && (column.tooltip = [].concat(title ? `<font style='font-weight:bold;'>${Tyan.t(title)}</font>` : []).concat(Tyan.t(prompt)).join('<br>'))

	// 添加 filter 图标
	columnTools = columnTools.concat((filterProp && getColumnFilterTool({ filter, ...columnPar })) ?? [])

	columnTools.length && (column.tools = columnTools)

	// 编辑列
	if (colType === '_columns') {
		column.handleEdit = handleEdit
		column.handleBatchEdit = handleBatchEdit
	} else if (handleEdit && edit && colType !== '_files') {
		edit = (Array.isArray(edit) || typeof edit !== 'object') ? {} : { ...edit }
		const onChange = edit.onChange // 自定义onChange事件
		delete edit.onChange
		column.handleEdit = (...args) => setTimeout(() => [handleEdit, onChange].forEach(fn => fn && fn(...args)))
		column.edit = syncfusionEditTypes.includes(colType) ? { ...edit } : reconfigEdit(edit)
		// 编辑列不可排序
		column.sortable = false
	} else
		filterProp ? (column.sortable = sortable || (sortable === undefined && (search || filter))) : (sortable != undefined && (column.sortable = sortable))
	// console.log('sortable:', 'filterProp', filterProp, 'have sortable', Object.keys(column).includes('sortable'), column.sortable)

	const cell = column.cell = { bind: {} }
	if (colType === '_files') {
		delete column.dataIndex
		cell.bind = { tools: `{${forViewModel ? '' : 'record.'}files${key}}` }
		column.align = column.align || 'center'
	} else {
		cell.tools = []
		const tools = toolsPar || _tools
		tools && tools.forEach((o, i) => {
			const { _tool, _tooltip = true, tooltip, bind, icon, ui, disabled, hidden, handler, text, ...rest } = reconfigButton(o)
			cell.tools.push({
				...getBindedProps({ _tooltip, tooltip, bind, icon, ui, disabled, hidden, text: text == undefined ? _tool : text }, that, `${key}_${i}`, forViewModel),
				...rest,
				...(handler ? { handler: (grid, { record }) => checkGridData([record.data.id]).then(r => r && handler(that, record.data, record, grid)) } : {})
			})
		})
		// cell.tools.length && (column.cell = cell)
	}

	// 处理 tooltip, ui, style
	if (!['_button', '_files'].includes(colType)) {
		if (tooltip) {
			const tooltipField = `${forViewModel ? '' : 'record.'}tooltip${key}`
			cell.tools.push({
				iconCls: 'md-icon-info-outline', zone: 'tail', ui: 'size14',
				...(typeof tooltip === 'function'
					? { bind: { tooltip: `{${tooltipField}}`, hidden: `{!${tooltipField}}` } }
					: { tooltip })
			})
		}

		Object.entries({ ui, style }).forEach(([k, v]) => v !== undefined && (
			typeof v === 'function'
				? (cell.bind[k] = `{${forViewModel ? '' : 'record.'}${k}${key}}`)
				: cell[k] = v
		))
	} else {
		Object.entries({ tooltip, ui, style }).forEach(([k, v]) => v !== undefined && (column[k] = v))
	}

	// 清除空的cell
	cell.tools && !cell.tools.length && delete cell.tools
	cell.bind && !Object.keys(cell.bind).length && delete cell.bind
	!Object.keys(cell).length && delete column.cell

	// 处理batchEdit
	if (handleBatchEdit && batchEdit && !batchEdit.disabled) {
		const { disabled, title, formInfo, initValues = {}, ...bathEditProps } = batchEdit
		const tools = column.tools = column.tools || []
		tools.unshift({
			// disabled: bReadOnly,
			iconCls: 'x-fa fa-edit', zone: 'tail',
			ui: 'action',
			handler: () => formInfo
				? Tyan.pubForm.showDialog(title, formInfo.Form, { ...formInfo.props, onSave: handleBatchEdit })
				: Tyan.pubForm.showDialog(title, BatchEditor,
					{
						batchEdit: bathEditProps,
						onSave: handleBatchEdit,
						initValues
					}
				)
		})
	}

	// console.log('debug:', column)
	return column
}

const genFilesFieldFn = ({ name, title, downloadAll, edit, checkGridData, handleEdit }) => data => {
	let list = data[name]
	const id = data.id
	// 如果有直接数据并且不是数组或是对象数据，报错
	if (list && !Array.isArray(list)) {
		console.error(`记录 ${id} _files列[${title || name}] 数据格式错误，应为数组`)
		return []
	}

	if (list && list.length && typeof list[0] === 'object') {
		if (edit) {
			console.error(`记录 ${id} _files列[${title || name}] 不是平铺数据，不可使用编辑参数`)
			return []
		}
	} else {
		// 重新按平铺数据方式取list
		const { list: temp } = getListFromValues(name, data[name], data)
		list = temp
	}

	const listeners = (() => {
		const handleContextMenu = e => {
			if (list.length <= 2) return
			e.stopEvent()
			showContextMenu(e.getXY(), [
				{
					text: '下载所有文件', ui: 'action',
					handler: () => checkGridData([data.id]).then(r => r && window.open(getDownloadUrl(list, `${downloadAll || title || name}_${id}`)))
				},
			])
		}

		return {
			contextmenu: { element: 'element', fn: handleContextMenu },
			longpress: { element: 'element', fn: handleContextMenu },
		}
	})()

	const ret = list.map(v => {
		return {
			iconCls: `x-fa fa-file-${getFileIcon(v.FileExt)}`,
			ui: 'action',
			tooltip: genFileText(v.FileName, v.FileExt, v.FileSize),
			handler: () => checkGridData([data.id]).then(r => r && window.open(getDownloadUrl(v))),
			listeners,
		}
	})

	if (edit) {
		const calcProps = props => {
			return Object.entries(props).reduce((prev, [key, value]) => {
				value && (!Array.isArray(value) && typeof value === 'object'
					? value = calcProps(value)
					: typeof value === 'function' && (value = value(data))
				)
				prev[key] = value
				return prev
			}, {})
		}

		edit = edit === true ? {} : edit
		let { onChange, ...rest } = edit || {}
		const { filesProps = {}, dialogProps = {}, ...editProps } = calcProps(rest)

		const editorHandler = () => {
			const doEdit = () => {
				Tyan.pubForm.showDialog(title, FilesEditor, {
					initValuesBasic: data,
					title, name, filesProps,
					onConfirm: (changedValues, typesOfChangedValues) => {
						const arg = { id: data.id, name, changedValues, typesOfChangedValues }
						// console.log('changedValues:', changedValues, typesOfChangedValues)
						handleEdit(arg)
						onChange && onChange(arg)
					}
				}, dialogProps)
			}

			checkGridData([data.id]).then(r => r && doEdit())
		}

		ret.push({
			iconCls: 'x-fa fa-edit',
			ui: 'action',
			zone: 'end',
			...editProps,
			handler: editorHandler
		})
	}

	return ret
}

const genModelFields = ({ columns, fields, checkGridData, handleEdit, keyPrev = '' }) => {
	const genEditFields = (edit, i) => {
		const { onChange, ...props } = edit
		Object.entries(props).forEach(([k, v]) => {
			v && typeof v === 'function' && fields.push({ name: `edit_${k}${keyPrev}${i}`, calculate: v, depends: [] })
		})
	}

	columns.reduce((fields, column, i) => {
		const {
			// _button, _menubuttons, _tool,
			_buttons, _tools, tools, _columns, items,
			_files, name: colName, downloadAll,
			tooltip, disabled, hidden, text, ui, style, icon, edit
		} = column

		if (_buttons || tools || _tools || _columns) genModelFields({ columns: _buttons || _tools || tools || items, fields, checkGridData, keyPrev: `${keyPrev}${i}_` })
		// if (_menubuttons !== undefined) getButtonsFields(_menubuttons, sum, `${keyPrev}${i}_`)
		// if (_button !== undefined || _menubuttons !== undefined || _tool !== undefined) {
		Object.entries({ tooltip, disabled, hidden, text, ui, icon, style })
			.forEach(([k, v]) => v && typeof v === 'function' && fields.push({ name: `${k}${keyPrev}${i}`, calculate: v, depends: [] }))
		// }
		if (_files !== undefined) {
			const name = colName || _files
			fields.push({
				name: `files${keyPrev}${i}`, calculate: genFilesFieldFn({ name, title: _files, downloadAll, edit, checkGridData, handleEdit }), depends: []
			})
		} else if (edit && edit !== true && !syncfusionEditTypes.includes(getColumnType(column))) {
			genEditFields(edit, i)
		}

		return fields
	}, fields)
}

// const genViewModelFormulaFns = (columns, prev, keyPrev = '') => {
//   return columns.reduce((sum, { _button, _buttons, _menubuttons, _tools, tools, _tool, tooltip, disabled, hidden, text, ui, icon, }, i) => {
//     if (_buttons || _tools || tools) genViewModelFormulaFns(_buttons || _tools || tools, sum, `${keyPrev}${i}_`)
//     // if (_menubuttons !== undefined) getButtonsFormulaFns(_menubuttons, sum, `${keyPrev}${i}_`)
//     if (_button !== undefined || _menubuttons !== undefined || _tool != undefined) {
//       const props = { tooltip, disabled, hidden, text, ui, icon }
//       Object.keys(props).forEach(o => props[o] && typeof props[o] === 'function' && (sum[`${o}${keyPrev}${i}`] = props[o]))
//     }
//     return sum
//   }, prev)
// }

// 修改新模式为一个对象参数，兼容旧模式：columns, prevProps, checkGridData
export const getModel = (columns, prevProps = {}, checkGridData = truePromise) => {
	let handleEdit, multiSelect

	if (columns && !Array.isArray(columns)) {
		prevProps = columns.prevProps || {}
		checkGridData = columns.checkGridData || truePromise
		handleEdit = columns.handleEdit
		multiSelect = columns.multiSelect
		columns = columns.columns
	}

	let selectable = multiSelect && multiSelect.selectable || undefined
	selectable = typeof selectable === 'string'
		? o => o[selectable]
		: typeof selectable === 'function'
			? selectable : undefined

	const { fields: prevFields = [], ...otherProps } = prevProps
	const fields = [...prevFields]
	selectable && fields.push({ name: selectionCheckboxClsField, calculate: o => selectable(o) ? '' : disableSelectionCls, depends: [] })
	columns && genModelFields({ columns, fields, checkGridData, handleEdit })

	return Ext.define(null, {
		extend: 'Ext.data.Model',
		...otherProps,
		fields,
	})
}


// 修改新模式为一个对象参数，兼容旧模式：columns, prevFns, checkGridData
export const getViewModel = (columns, prevFns = {}, checkGridData = truePromise) => {
	if (columns && !Array.isArray(columns)) {
		prevFns = columns.prevFns || {}
		checkGridData = columns.checkGridData || truePromise

		columns = columns.columns
	}
	const formulaFns = { ...prevFns }
	const fields = []
	const formulas = {}
	// columns && genViewModelFormulaFns(columns, formulaFns)
	columns && genModelFields({ columns, fields, checkGridData })
	for (const [n, v] of Object.entries(formulaFns).concat(fields.map(({ name: n, calculate: v }) => [n, v])))
		formulas[n] = { get: get => v(get('record').data, get('record')) }

	return { formulas }
}

export const tplByColumns = columns => {
	const cols = getDataCols(columns)
	return data => {
		return (<div>
			{
				cols
					.filter(c => c.phone != false && c.type !== '_')
					.map(c => (
						<div key={c.desc} style={{ fontSize: "12px", color: "#616161" }}>
							<div>{`${c.desc}: ${c.phoneTranFn(data[c.name], data)}`}</div>
						</div>
					))
			}
			{cols.reduce((s, c, i) => (c => c.phone != false && c['_'] === undefined && s.push(<div key={c.desc} style={{ fontSize: "12px", color: "#616161" }}>
				<div>{`${c.desc}: ${c.phoneTranFn(data[c.name], data)}`}</div>
			</div>), s), [])}
		</div>)
	}
}

const tranPass = o => o

// 从columns中取得数据列(_text, _number, _date, _int, _tree), 返回列项配置：[{type, desc, index, width, tran, search, filter}]
export const getDataCols = (columns, isExport = false) => {
	const tranFn = {
		'_date': o => o && o != nullDate && new TDate(o).toString('yyyy/MM/dd') || '',
		'_datetime': o => o && o != nullDate && new TDate(o).toString('yyyy/MM/dd HH:mm') || '',
		'_lineProcessing': v => v && v[1] && (Array.isArray(v[1]) ? v[1] : [v[1]]).map(s => v[0][s]).filter(o => o) || ''
	}
	const ret = []
	for (const c of columns) {
		const v = {}
		const type = v.type = getColumnType(c)
		if (isExport && c.export == false || !dataFieldTypes.includes(type) || c.local)
			continue
		v.dataType = c.dataType || type
		v.desc = c[type]
		v.name = c.name || c[type]
		v.field = c.field || v.name
		v.search = c.search
		v.filter = c.filter == undefined && c.search || c.filter
		v.sortable = c.sortable == undefined && c.filter || c.sortable
		v.width = c.width || c.minWidth;
		v.format = c.format;
		(!v.width || (typeof v.width === 'string' && v.width.includes('%'))) && (v.width = 100)
		v.width = parseInt(v.width)
		v.width = Math.max(v.width, 10);
		v.phone = c.phone
		v.defaultExport = c.defaultExport == undefined ? true : !!c.defaultExport
		v.exportTranFn = c.locale
			? (...args) => Tyan.t((c.exportTranFn || tranFn[v.dataType] || tranPass)(...args), c.locale)
			: c.exportTranFn || tranFn[v.dataType] || tranPass
		v.phoneTranFn = c.phoneTranFn || tranFn[v.dataType] || tranPass
		ret.push(v)
	}
	return ret
}

// 组织用于发送到后台的returnFields, searchFields, selectFields
export const genFieldsArgs = (columns) => {
	const cols = getDataCols(columns)
	const ret = { searchFields: [], selectFields: [], returnFields: [] }
	for (const v of cols) {
		if (!v.field) continue
		!ret.returnFields.includes(v.field) && ret.returnFields.push(v.field)
		v.search && !ret.searchFields.includes(v.field) && ret.searchFields.push(v.field)
		v.filter && Array.isArray(v.filter) && ['select', 'combo'].includes(v.filter[0]) && !v.filter[2]
			&& !ret.selectFields.includes(v.filter[1] || v.field) && ret.selectFields.push(v.filter[1] || v.field)
	}

	!ret.selectFields.length && delete ret.selectFields
	!ret.searchFields.length && delete ret.searchFields
	!ret.returnFields.length && delete ret.returnFields

	return ret
}

/**
 * 重新组织请求数据：
 * 1、sort: 从desc转换成field
 * @param {*} columns 
 * @param {*} param1 
 */
export const rearrangeQueryData = (columns, exportColumns, { sort, pivot, ...rest }) => {
	const args = genFieldsArgs(columns)
	const cols = getDataCols(columns)
	sort && (sort = sort.map(([n, v]) => {
		const c = cols.find(o => o.desc == n)
		return [c ? c.field : n, v]
	}))
	// console.log('sort:', sort)
	const ret = { sort, ...args, pivot, ...rest }
	if (exportColumns) {
		const { returnFields } = genFieldsArgs(exportColumns)
		returnFields && (ret.returnFields = returnFields)
	}
	return ret
}

const sampleTrans = (() => {
	const ret = {}
	ret._date = v => typeof v === 'string' ? Tyan.Date.localToUtcValue(v) : v
	ret._datetime = ret._date
	return ret
})()

// 根据column中的配置重新计算list值
export const recalcDataByColumns = (columns, { list, /* selectValues,  */...rest }) => {
	// console.log('ret:', list)
	if (!list || !columns)
		return { list, /* selectValues,  */...rest }

	const cols = getDataCols(columns)
	// console.log('list before calced:', list)
	// console.log('cols:', cols/* , selectValues */)
	list = list.map(o => {
		const ret = { ...o }
		const dfs = Object.keys(o)    // data Fields
		ret.id = o.id
		for (const c of cols)
			ret[c.name] = (Tyan.sysMode === 'sample' && sampleTrans[c.type] || tranPass)(dfs.includes(c.field) ? o[c.field] : dfs.includes(c.name) ? o[c.name] : undefined)
		return ret
	})

	// console.log('list after calced:', { ...list })
	// const newSelectValues = {}
	// selectValues = selectValues || {}
	// for (const v of cols) v.filter && Array.isArray(v.filter) && v.filter[0] == 'select' && !v.filter[2] && (newSelectValues[v.name] = selectValues[v.field])

	return { list, /* selectValues: newSelectValues, */ ...rest }
}

// 根据columns组建contextMenu
export const genContextMenu = columns => {
	let ret = columns.reduce((r, columnPar) => {
		const { _button, name, text, _buttons, _menubuttons, _flow, noContextMenu } = columnPar
		const type = getColumnType(columnPar)
		if (!type) {
			return null
		}
		const { ...column } = reconfigColumn(type, columnPar/* , that, key, forViewModel, checkGridData */)

		r = r.concat(!noContextMenu && (((_button != undefined || _flow !== undefined) && column) || _buttons || _menubuttons) || [])
		return r
	}, [])
	return ret.length ? ret : null
}
